export const NoResults = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="200"
    height="88"
    viewBox="0 0 200 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M195.564 67.3187L198.75 67.727"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.67 65.272L196.531 62.6673"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.374 69.4207C195.605 68.8848 196.14 67.391 195.568 66.0842C194.997 64.7773 193.536 64.1523 192.306 64.6882C191.075 65.224 190.54 66.7178 191.112 68.0246C191.683 69.3315 193.144 69.9565 194.374 69.4207Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M178.891 67.9516C178.655 67.4398 178.874 66.8419 179.375 66.6176L181.04 65.8644C181.311 65.7379 181.627 65.7494 181.898 65.8874L183.644 66.7786C184.139 67.0316 184.347 67.6411 184.105 68.1413C183.863 68.6415 183.264 68.837 182.768 68.584L181.449 67.9113L180.216 68.4691C179.715 68.6933 179.121 68.469 178.885 67.9573L178.891 67.9516Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M183.557 59.7178C183.712 59.1774 184.265 58.8669 184.795 59.0164L186.547 59.5224C186.835 59.6029 187.071 59.8156 187.186 60.0973L187.93 61.9085C188.143 62.4259 187.901 63.0182 187.394 63.2424C186.887 63.4609 186.305 63.2252 186.092 62.7077L185.533 61.3393L184.237 60.9655C183.707 60.8103 183.407 60.2526 183.563 59.7121L183.557 59.7178Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M179.559 63.0184C179.472 62.4607 179.847 61.9489 180.388 61.8684L182.191 61.5982C182.485 61.5522 182.791 61.65 183.009 61.857L184.444 63.1909C184.853 63.5703 184.882 64.2143 184.513 64.6283C184.144 65.0423 183.516 65.0653 183.107 64.6858L182.024 63.6796L180.688 63.8808C180.146 63.9613 179.633 63.5761 179.553 63.0241L179.559 63.0184Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M182.861 77.0416C183.08 77.559 183.662 77.8063 184.169 77.5993L185.851 76.8978C186.127 76.7828 186.335 76.5471 186.421 76.2539L186.951 74.3679C187.101 73.8332 186.796 73.264 186.266 73.103C185.736 72.9421 185.183 73.2468 185.033 73.7815L184.629 75.2074L183.385 75.7306C182.878 75.9434 182.642 76.5356 182.861 77.0531V77.0416Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M192.084 79.2264C192.585 79.4794 193.196 79.2897 193.438 78.7952L194.256 77.1681C194.389 76.9036 194.394 76.5873 194.268 76.3113L193.444 74.5347C193.208 74.0287 192.608 73.7987 192.101 74.023C191.594 74.2415 191.37 74.8337 191.606 75.3396L192.228 76.6793L191.623 77.8868C191.376 78.3755 191.583 78.9792 192.084 79.2322V79.2264Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.94 79.9049C187.291 80.3419 187.919 80.4224 188.351 80.0831L189.78 78.9447C190.016 78.7607 190.149 78.4733 190.149 78.1685V76.2079C190.143 75.6502 189.693 75.1902 189.14 75.1787C188.587 75.1672 188.138 75.6099 188.138 76.1676V77.6453L187.084 78.4848C186.652 78.824 186.588 79.4622 186.94 79.8992V79.9049Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.917 63.0815C184.012 63.4897 183.39 64.2889 183.303 65.1341L182.629 71.8267L188.212 75.679C188.921 76.1677 189.94 76.2137 190.839 75.8055C191.738 75.3972 195.344 71.9762 193.184 67.0315C191.023 62.0868 185.815 62.6675 184.917 63.0757V63.0815Z"
      fill="#7A68FA"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M193.219 67.129C193.219 67.129 191.047 68.072 187.746 69.5094C185.338 70.5558 186.617 66.7265 187.538 64.4899C187.861 63.7022 189.128 63.179 189.872 63.5297C191.145 64.1334 192.372 65.2086 193.178 67.0485L193.213 67.129H193.219Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M193.202 67.1233C193.202 67.1233 191.03 68.0663 187.729 69.5037C185.321 70.5502 189.002 72.2233 191.278 73.0685C192.078 73.3675 193.323 72.7983 193.571 72.0163C193.991 70.6767 194.037 69.0437 193.236 67.2038L193.202 67.1233Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.3822 11.771C49.305 20.2058 46.3092 31.7799 45.5891 42.5146L45.134 42.9918L42.2303 38.3115L36.2618 43.63L34.4297 38.7888L27.983 44.5039L25.7534 39.4212L19.3067 45.3031L17.2327 40.4562L10.7859 46.2518L8.30862 41.1231L1.97711 46.7636C-7.76502 11.8113 43.4229 12.392 52.1107 12.392C53.9543 12.392 55.723 12.1562 57.3822 11.771Z"
      fill="black"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M138.811 23.2474L139.911 19.6423C139.911 19.6423 140.654 16.779 143.039 17.9289C145.424 19.0789 143.615 21.4707 143.615 21.4707L141.311 24.3053"
      fill="white"
    />
    <path
      d="M138.811 23.2474L139.911 19.6423C139.911 19.6423 140.654 16.779 143.039 17.9289C145.424 19.0789 143.615 21.4707 143.615 21.4707L141.311 24.3053"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M117.666 81.7218C117.666 81.7218 122.615 79.9509 125.23 84.7979H113.933L117.666 81.7218Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M111.128 30.1357C111.128 30.1357 99.3004 45.3781 102.256 65.7895C105.211 86.2008 114.654 86.3849 117.529 83.4928C118.756 82.2623 118.422 80.5202 117.972 79.0425C110.345 53.8992 130.1 40.7727 131.448 42.3308"
      fill="white"
    />
    <path
      d="M111.128 30.1357C111.128 30.1357 99.3004 45.3781 102.256 65.7895C105.211 86.2008 114.654 86.3849 117.529 83.4928C118.756 82.2623 118.422 80.5202 117.972 79.0425C110.345 53.8992 130.1 40.7727 131.448 42.3308"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.5738 83.6707C93.5738 83.6707 98.5226 81.8998 101.138 86.7468H89.8406L93.5738 83.6707Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.9449 82.7106C61.9449 82.7106 66.8937 80.9397 69.5093 85.7867H58.2117L61.9449 82.7106Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M72.8337 48.6212C72.5168 49.5699 69.3539 77.6053 81.2219 75.5814L88.8843 73.1493L86.5164 49.1387L72.8337 48.6212Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M139.214 21.5687C113.583 3.25026 79.1195 -8.55959 58.7941 10.3798C37.1264 30.5727 48.28 71.8611 48.28 71.8611C48.28 71.8611 51.4025 86.3848 58.7307 85.7984C66.0532 85.2119 62.0722 74.7705 61.5652 70.1075C61.0583 65.4388 60.5858 54.1234 65.4713 49.3454C65.4713 49.3454 67.1881 50.3114 71.0712 50.8403C74.9542 51.3693 77.3105 51.191 77.3105 51.191C77.3105 51.191 75.4439 64.0818 79.1771 74.5348C82.9103 84.9877 87.2082 87.69 91.5521 86.4826C95.896 85.2751 93.7471 79.6175 93.7471 79.6175C93.7471 79.6175 92.785 76.6564 92.4969 74.3565C91.1315 63.4666 94.594 52.318 103.161 46.2234C130.619 28.3936 162.691 62.6559 162.691 62.6559L168.636 60.2468C164.909 49.6041 157.765 35.9142 144.18 25.2773C142.573 24.0181 140.919 22.7819 139.226 21.5687"
      fill="white"
    />
    <path
      d="M139.214 21.5687C113.583 3.25026 79.1195 -8.55959 58.7941 10.3798C37.1264 30.5727 48.28 71.8611 48.28 71.8611C48.28 71.8611 51.4025 86.3848 58.7307 85.7984C66.0532 85.2119 62.0722 74.7705 61.5652 70.1075C61.0583 65.4388 60.5858 54.1234 65.4713 49.3454C65.4713 49.3454 67.1881 50.3114 71.0712 50.8403C74.9542 51.3693 77.3105 51.191 77.3105 51.191C77.3105 51.191 75.4439 64.0818 79.1771 74.5348C82.9103 84.9877 87.2082 87.69 91.5521 86.4826C95.896 85.2751 93.7471 79.6175 93.7471 79.6175C93.7471 79.6175 92.785 76.6564 92.4969 74.3565C91.1315 63.4666 94.594 52.318 103.161 46.2234C130.619 28.3936 162.691 62.6559 162.691 62.6559L168.636 60.2468C164.909 49.6041 157.765 35.9142 144.18 25.2773C142.573 24.0181 140.919 22.7819 139.226 21.5687"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.3041 51.1909C77.3041 51.1909 63.5406 52.7203 55.6709 41.2095L77.3041 51.1909Z"
      fill="white"
    />
    <path
      d="M77.3041 51.1909C77.3041 51.1909 63.5406 52.7203 55.6709 41.2095"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M129.334 29.9231C129.334 29.9231 125.9 27.7957 125.474 27.445C125.047 27.0942 124.016 25.858 124.99 24.4264C125.963 23.0005 127.53 23.3569 127.98 23.7709C128.429 24.1849 131.367 27.5715 131.367 27.5715"
      fill="white"
    />
    <path
      d="M129.334 29.9231C129.334 29.9231 125.9 27.7957 125.474 27.445C125.047 27.0942 124.016 25.858 124.99 24.4264C125.963 23.0005 127.53 23.3569 127.98 23.7709C128.429 24.1849 131.367 27.5715 131.367 27.5715"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M140.222 39.7779C141.876 39.7779 143.218 38.4393 143.218 36.7881C143.218 35.1369 141.876 33.7983 140.222 33.7983C138.567 33.7983 137.226 35.1369 137.226 36.7881C137.226 38.4393 138.567 39.7779 140.222 39.7779Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M140.222 38.0473C140.919 38.0473 141.484 37.4835 141.484 36.7881C141.484 36.0927 140.919 35.5289 140.222 35.5289C139.525 35.5289 138.96 36.0927 138.96 36.7881C138.96 37.4835 139.525 38.0473 140.222 38.0473Z"
      fill="black"
    />
    <path
      d="M147.867 38.49C149.521 38.49 150.863 37.1514 150.863 35.5002C150.863 33.849 149.521 32.5104 147.867 32.5104C146.212 32.5104 144.871 33.849 144.871 35.5002C144.871 37.1514 146.212 38.49 147.867 38.49Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.867 36.7592C148.563 36.7592 149.128 36.1954 149.128 35.5C149.128 34.8046 148.563 34.2408 147.867 34.2408C147.17 34.2408 146.605 34.8046 146.605 35.5C146.605 36.1954 147.17 36.7592 147.867 36.7592Z"
      fill="black"
    />
    <path
      d="M159.741 59.6774L167.063 56.1817L168.625 60.2409L162.679 62.65L159.741 59.6774Z"
      fill="#7A68FA"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M185.321 66.3529C184.566 66.8646 183.54 66.6634 183.028 65.9159C182.135 64.5993 180.902 63.8805 179.554 63.8805H179.536C177.877 63.8805 176.195 64.9902 174.922 66.8991C174.305 67.8305 173.706 68.8885 173.124 69.9005C171.402 72.9075 168.884 77.352 165.214 75.8916C161.78 74.5232 162.933 70.9986 163.808 68.2963C164.177 67.1463 164.557 65.9619 164.799 64.6912C165.03 63.4666 164.943 62.5179 164.742 61.8049L167.812 60.563C168.216 61.7647 168.406 63.3343 168.037 65.3007C167.761 66.7784 167.328 68.1238 166.948 69.3082C165.98 72.3153 166.067 72.6661 166.574 72.8903C167.392 73.264 169.189 70.1419 170.261 68.2733C170.866 67.2096 171.5 66.1057 172.174 65.0822C174.057 62.2361 176.736 60.5975 179.519 60.586H179.559C182.002 60.586 184.26 61.8566 185.77 64.0645C186.283 64.8177 186.081 65.8412 185.332 66.3529H185.321Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
